export enum ChatFormSetupActionTypes {
    API_RESPONSE_SUCCESS = '@@chatFormSetup/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@chatFormSetup/API_RESPONSE_ERROR',
    CHAT_SETUP_LIST = '@@chatFormSetup/CHAT_SETUP_LIST',
    ADD_CHAT_SETUP = '@@chatFormSetup/ADD_CHAT_SETUP',
    SHOW_CHAT_SETUP = '@@chatFormSetup/SHOW_CHAT_SETUP',
    UPDATE_CHAT_SETUP = '@@chatFormSetup/UPDATE_CHAT_SETUP',
    DELETE_CHAT_SETUP = '@@chatFormSetup/DELETE_CHAT_SETUP',
}